import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { withStyles } from '@mui/styles';
import Checkbox from '@mui/material/Checkbox';
import TableSortLabel from '@mui/material/TableSortLabel';
import Tooltip from '@mui/material/Tooltip';
import { withTranslation } from 'react-i18next';

class EnhancedTableHead extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  createSortHandler = (property, field) => (event) => {
      this.props.onRequestSort(event, property, field);
  };

  render() {
    const {
      onSelectAllClick,
      order,
      orderBy,
      NumRowsSelected,
      rowCount,
      sortId,
      t
    } = this.props;
    const rows = [
      {
        id: 'picture',
        numeric: false,
        disablePadding: false,
        label: t("Report.inActive.Picture"),
        padding: '10px',
        field: 'picture_url'
      },
      {
        id: 'user',
        numeric: false,
        disablePadding: false,
        label: t("Report.inActive.Name"),
        padding: '10px',
        field: 'name'
      },
      {
        id: 'username',
        numeric: false,
        disablePadding: false,
        label: t("Report.inActive.UserName"),
        padding: '10px',
        field: 'username'
      },
      {
        id: 'associated account',
        numeric: false,
        disablePadding: false,
        label: t("Report.inActive.AssociatedAccount"),
        padding: '10px',
        field: 'name'
      },
      {
        id: 'phone',
        numeric: false,
        disablePadding: false,
        label: t("Report.inActive.Phone"),
        padding: '10px',
        field: 'phone'
      },
      {
        id: 'createdon',
        numeric: false,
        disablePadding: false,
        label: t("Report.inActive.CreatedOn"),
        padding: '10px',
        field: 'created_on'
      },
      {
        id: 'lastloginon',
        numeric: false,
        disablePadding: false,
        label: t("Report.inActive.LastLoginOn"),
        padding: '10px',
        field: 'last_login_on'
      },
      {
        id: 'status',
        numeric: false,
        disablePadding: false,
        label: t("Report.inActive.Status"),
        padding: '10px',
        field: 'is_enabled'
      },
      {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: t("Report.inActive.Actions"),
        padding: '10px',
      },
    ];
    return (
      <React.Fragment>
        <TableHead sx={{ height: '56px' }}>
          <TableRow>
            <TableCell sx={{ padding: '0 12px' }}>
              <Checkbox
                indeterminate={NumRowsSelected > 0 && NumRowsSelected < rowCount}
                checked={NumRowsSelected === rowCount}
                onChange={onSelectAllClick}
                sx={{ '&.Mui-checked': { color: '#0ae' }, '&.MuiCheckbox-indeterminate': {color: '#0ae'} }}
              />
            </TableCell>
            {rows.map((row) => {
              return (
                <TableCell
                  key={row.id}
                  numeric={row.numeric}
                  padding={"none"}
                  sortDirection={orderBy === row.field ? order : false}
                  style={{ color: 'rgba(0, 0, 0, 0.54)'}}
                >
                {['picture', 'actions', 'createdon', 'lastloginon'].includes(row.id) ?
                  (<TableSortLabel style={{ cursor: 'text' }}>
                      {row.label}
                    </TableSortLabel>
                   ) : (
                    <Tooltip
                      title={t("Global.Label.Filter.Sort")}
                      placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                      enterDelay={300}>
                      <TableSortLabel
                        active={orderBy === row.field && sortId === row.id}
                        direction={order}
                        onClick={this.createSortHandler(row.id, row.field)}>
                        {row.label}
                      </TableSortLabel>
                    </Tooltip>
                  )}
                </TableCell>
              );
            }, this)}
          </TableRow>
        </TableHead>
      </React.Fragment>
    );
  }
}

EnhancedTableHead.propTypes = {
  NumRowsSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  sortId: PropTypes.string.isRequired
};

export default withStyles()(withTranslation()(EnhancedTableHead));



// WEBPACK FOOTER //
// ./src/components/reports/users-inactive-report/EnhancedTableHead.index.js